// extracted by mini-css-extract-plugin
export var box = "_5r-1";
export var checkboxRow = "_5r-8";
export var checked = "_5r-2";
export var descriptionSpacer = "_5r-a";
export var disabled = "_5r-3";
export var icon = "_5r-6";
export var input = "_5r-0";
export var labelSpacer = "_5r-9";
export var medium = "_5r-5";
export var small = "_5r-4";
export var text = "_5r-7";